module.exports = __webpack_public_path__ + "static/media/network_diagram.e6811cec.png";